const getMetricsIntro = () => {
    return `
//(OPTIONAL)
const Metrics = ({ data, isLoading, max = 5, thickness = 5 }) => {

};
export default Metrics;

    `;
}

export default getMetricsIntro;
